module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAABGdBTUEAALGPC/xhBQAAABp0RVh0U29mdHdhcmUAUGFpbnQuTkVUIHYzLjUuMTAw9HKhAAAAVklEQVQoU5WSyw0AIAhD2Yn9Z8NwqJIKKCZcWp58VCQ5ZpbJR1NV84DCAPsCAVAE2NtlogGgTAYVE8pkvy0GQ+xf22CgXddXS1n/z6HHax0/HA/WfY0FdJiCsdTQZjwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/close.png
// module id = /TeD
// module chunks = 1